import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { createForm } from 'rc-form';

import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

import InputPasswordValidation from './InputPasswordValidation';
import MensajeError from './MensajeError';

class CambioContrasena extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clave: undefined,
            errorClave: false,
            showPasswordPrevious: false,
            showNewPassword: false,
            showPasswordRepeat: false
        };
    }

    submit = () => {
        this.props.form.validateFields((err, values) => {
            if (this.state.clave){
                if (!err) {
                    const { id } = this.props.match.params;

                    const userObject = {
                        "USER_ID": id,
                        "CURRENT_PASS": values.clavePrevious,
                        "NEW_PASS": this.state.clave,
                        "NEW_PASS_TO_COMPARE": values.claveRepeat
                    };

                    this.props.actualizarContrasena(userObject);
                }
            }
            else {
                this.setState({ errorClave: true });
            }
        });
    }

    onInputPasswordChange(event) {
        if (event.statusInputPass) {
            this.setState({ clave: event.target.value, errorClave: false });
        }
        else {
            this.setState({ clave: undefined, errorClave: false });
        }
    }

    showPasswordPreviousHandle(event) {
        this.setState({ showPasswordPrevious: !this.state.showPasswordPrevious });
    }

    showNewPasswordHandle(event) {
        this.setState({ showNewPassword: !this.state.showNewPassword });
    }

    showPasswordRepeatHandle(event) {
        this.setState({ showPasswordRepeat: !this.state.showPasswordRepeat });
    }

    componentDidMount() {
        const { getConfiguracionContrasena, setFlagAccesoDirecto } = this.props;
        getConfiguracionContrasena();
        setFlagAccesoDirecto();
    }

    componentWillUnmount() {
        this.props.reiniciarStateCambioContrasena();
    }

    render() {
        let errors;

        const validationRules = {
            'clavePrevious': [{ required: true, message: 'Debe ingresar la contraseña actual.' }],
            'claveRepeat': [{ required: true, message: 'Debe repetir la contraseña ingresada.' }]
        };

        const { getFieldProps, getFieldError } = this.props.form;
        const { executionContext, configuracionContrasena, routeToLogin, mensaje, loggedIn, exitoCambioPass } = this.props;        

        if (loggedIn && exitoCambioPass) {
            return <Redirect to="/" />;
        }
        else if (routeToLogin) {
            return <Redirect to="/login" />;
        }

        if (configuracionContrasena == undefined || configuracionContrasena.length == 0)
            return null;

        return (
            <div className="container off-marco-container">
                <div className="off-marco change-password">
                    <div className="row">
                        <div className="col-xs-12 image-gyf-color-change-password" />
                    </div>

                    <div className="row bottom-separator-xs">
                        <div className="col-xs-12 text-center">
                            <h2 className="form-signin-heading">Cambiar contraseña</h2>
                        </div>
                    </div>

                    {/*MSJE GLOBAL*/}
                    <MensajeError error={mensaje} />

                    <div className="row bottom-separator-xs">
                        <div className="col-xs-12">
                            <div className="row">
                                <div className="col-xs-6">
                                    <label className="label-primary">Contraseña actual</label>
                                </div>
                                <div className="col-xs-6">
                                    <div className="pull-right">
                                        <span className={"clickable zmdi-"
                                            + (this.state.showPasswordPrevious ? "eye-off" : "eye")}
                                            onClick={() => this.showPasswordPreviousHandle()} />
                                        <label className="label-primary label-eye clickable"
                                            onClick={() => this.showPasswordPreviousHandle()}>
                                            {(this.state.showPasswordPrevious ? "Ocultar" : "Mostrar")}
                                        </label>
                                    </div>                                    
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <input
                                        {...getFieldProps('clavePrevious', { rules: validationRules['clavePrevious'] }) }
                                        id="clavePrevious"
                                        name="clavePrevious"
                                        className={"form-control default-input " + (getFieldError('clavePrevious') && "error")}
                                        type={this.state.showPasswordPrevious ? "input" : "password"}
                                        maxLength="32" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    {(errors = getFieldError('clavePrevious')) ?
                                        <label className="error">
                                            {errors.join(',')}
                                        </label> : null}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row bottom-separator-xs">
                        <div className="col-xs-12">
                            <div className="row">
                                <div className="col-xs-8">
                                    <label className="label-primary">Contraseña nueva</label>
                                </div>
                                <div className="col-xs-4">
                                    <div className="pull-right">
                                        <span className={"clickable zmdi-"
                                            + (this.state.showNewPassword ? "eye-off" : "eye")}
                                            onClick={() => this.showNewPasswordHandle()} />
                                        <label className="label-primary label-eye clickable"
                                            onClick={() => this.showNewPasswordHandle()}>
                                            {(this.state.showNewPassword ? "Ocultar" : "Mostrar")}
                                        </label>
                                    </div>
                                </div>
                            </div>                            
                            <InputPasswordValidation
                                allowAphabeticalChars={configuracionContrasena.Alfabetica}
                                allowNumericChars={configuracionContrasena.Numerica}
                                allowSpecialChars={configuracionContrasena.CaracteresEspeciales}
                                allowCaseSensitiveChars={configuracionContrasena.CaseSensitive}
                                allowConsecutiveNumericChars={configuracionContrasena.PermiteNrosConsecutivos}
                                allowRepeatPosition={configuracionContrasena.PermiteRepetirPosicion}
                                allowIdenticalChars={configuracionContrasena.PermiteCaracteresIguales}
                                minCharsAllowed={configuracionContrasena.CaracteresMinimos}
                                id="InputClave" data-userinfo="Clave"
                                onParentChange={(e) => this.onInputPasswordChange(e)}
                                clave={this.state.clave}
                                showPassword={this.state.showNewPassword}
                                inputClass={"form-control default-input " + 
                                    ((this.state.errorClave == true) && "error")} />
                        </div>
                    </div>
                    <div className="row bottom-separator-md">
                        <div className="col-xs-12">
                            <div className="row">
                                <div className="col-xs-8">
                                    <label className="label-primary">Vuelva a escribir su nueva contraseña</label>
                                </div>
                                <div className="col-xs-4">
                                    <div className="pull-right">
                                        <span className={"clickable zmdi-"
                                            + (this.state.showPasswordRepeat ? "eye-off" : "eye")}
                                            onClick={() => this.showPasswordRepeatHandle()} />
                                        <label className="label-primary label-eye clickable"
                                            onClick={() => this.showPasswordRepeatHandle()}>
                                            {(this.state.showPasswordRepeat ? "Ocultar" : "Mostrar")}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <input
                                        {...getFieldProps('claveRepeat', { rules: validationRules['claveRepeat'] }) }
                                        className={"form-control default-input " + (getFieldError('claveRepeat') && "error")}
                                        id="claveRepeat"
                                        name="claveRepeat"
                                        type={this.state.showPasswordRepeat ? "input" : "password"}
                                        maxLength="32" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    {(errors = getFieldError('claveRepeat')) ?
                                        <label className="error">
                                            {errors.join(',')}
                                        </label> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            <GenericSimpleButton 
                                text="Guardar" 
                                buttonType="button" 
                                buttonClass="btn btn-cta" 
                                onClick={this.submit} />
                        </div>
                        <div className="col-xs-6">
                            <Link to="/">
                                <GenericSimpleButton
                                    text="Cancelar"
                                    buttonType="button"
                                    buttonClass="btn btn-secondary" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default createForm()(CambioContrasena);


// WEBPACK FOOTER //
// ./Portico/App/Screens/CambioContrasena/components/CambioContrasena.js